import { gql } from "@apollo/client";

export const MODERATE_BUSINESS_REVIEW = gql`
  mutation moderateBusinessReview($id: Int!, $input: BusinessReviewModeratorUpdateInput!) {
    moderateBusinessReview(id: $id, input: $input) {
      id
    }
  }
`;